import { render, staticRenderFns } from "./SalaPrincipal.vue?vue&type=template&id=e7e4d35c"
import script from "./SalaPrincipal.vue?vue&type=script&lang=js"
export * from "./SalaPrincipal.vue?vue&type=script&lang=js"
import style0 from "./SalaPrincipal.vue?vue&type=style&index=0&id=e7e4d35c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports